import React from "react";

const TextFieldFilter = ({
  handleKeyUp,
  handleChange,
  value,
  filterId,
  label,
  placeholder,
}) => {
  return (
    <div className={`TextFieldFilter_Wrapper ${filterId}_Filter_Wrapper`}>
      <div className="grid gap-3">
        <label className="label !font-normal text-black" htmlFor={filterId}>
          {label}
        </label>
        <input
          id={filterId}
          type="text"
          className="ease h-[40px] w-full rounded-lg border border-lightGrey px-4 text-[14px] font-medium leading-[normal] text-black transition-all duration-200 placeholder:text-[14px] placeholder:font-medium placeholder:text-txtColor focus:border-primary"
          placeholder={placeholder}
          onChange={(e) => {
            handleChange(e.target.value);
          }}
          value={value}
          onKeyUp={handleKeyUp}
        />
      </div>
    </div>
  );
};

export default TextFieldFilter;
